<template>
  <div class="products">
    <h1>Prodotti</h1>
    <div v-if="products && products.length > 0" class="table-wrap">
      <div>
        <router-link v-bind:to="{ name: 'NewProduct' }" class="">Nuovo prodotto</router-link>
      </div>
      <div>
          <nav aria-label="Pagine">
            <ul class="pagination">
              <li class="page-item">
                <a class="page-link" href="#" @click="gotoPage(0)">Prima</a>
              </li>
              <li class="page-item" v-show="page>1"><a class="page-link" href="#" @click="gotoPage(page-2)">{{page-1}}</a></li>
              <li class="page-item" v-show="page>0"><a class="page-link" href="#" @click="gotoPage(page-1)">{{page}}</a></li>
              <li class="page-item active" aria-current="page">
                <span class="page-link">
                  {{page+1}}
                  <span class="sr-only">(current)</span>
                </span>
              </li>
              <li class="page-item" v-show="page<Math.ceil(count/20)-1"><a class="page-link" href="#" @click="gotoPage(page+1)">{{page+2}}</a></li>
              <li class="page-item" v-show="page<Math.ceil(count/20)-2"><a class="page-link" href="#" @click="gotoPage(page+2)">{{page+3}}</a></li>
              <li class="page-item">
                <a class="page-link" href="#" @click="gotoPage(Math.ceil(count/20)-1)">Ultima</a>
              </li>
            </ul>
          </nav>
      </div>
      <div class="table-responsive">
          <table>
            <tr>
              <td width="">FID</td>
              <td width="">EAN</td>
              <td width="">Prodotto</td>
              <td width="">Prezzo</td>
              <td width="">Data</td>
              <td width="200" align="center">Azioni</td>
            </tr>
            <tr>
              <td width=""><input type="text" placeholder="fid" v-model="filters.sku"></td>
              <td width=""><input type="text" placeholder="ean" v-model="filters.ean"></td>
              <td width=""><input type="text" placeholder="nome" v-model="filters.name"></td>
              <td width=""></td>
              <td width=""></td>
              <td width="200" align="center">
                  <button class="src_btn" @click="getProducts">Cerca</button>
              </td>
            </tr>
            <tr v-for="product in products" v-bind:key="product">
              <td>{{ product.sku }}</td>
              <td>{{ product.ean }}</td>
              <td>{{ product.name }}</td>
              <td>{{ product.price }}</td>
              <td>{{ formatDate(product.date) }}</td>
              <td align="center">
                <router-link v-bind:to="{ name: 'EditProduct', params: { id: product._id } }">Modifica</router-link> |
                <a href="#" @click="deleteProduct(product._id)">Elimina</a>
              </td>
            </tr>
          </table>
      </div>
      <div>
          <nav aria-label="Pagine">
            <ul class="pagination">
              <li class="page-item">
                <a class="page-link" href="#" @click="gotoPage(0)">Prima</a>
              </li>
              <li class="page-item" v-show="page>1"><a class="page-link" href="#" @click="gotoPage(page-2)">{{page-1}}</a></li>
              <li class="page-item" v-show="page>0"><a class="page-link" href="#" @click="gotoPage(page-1)">{{page}}</a></li>
              <li class="page-item active" aria-current="page">
                <span class="page-link">
                  {{page+1}}
                  <span class="sr-only">(current)</span>
                </span>
              </li>
              <li class="page-item" v-show="page<Math.ceil(count/20)-1"><a class="page-link" href="#" @click="gotoPage(page+1)">{{page+2}}</a></li>
              <li class="page-item" v-show="page<Math.ceil(count/20)-2"><a class="page-link" href="#" @click="gotoPage(page+2)">{{page+3}}</a></li>
              <li class="page-item">
                <a class="page-link" href="#" @click="gotoPage(Math.ceil(count/20)-1)">Ultima</a>
              </li>
            </ul>
          </nav>
      </div>
    </div>
    <div v-else>
      Non ci sono ancora prodotti.. Creane uno nuovo!<br /><br />
      <router-link v-bind:to="{ name: 'NewProduct' }" class="add_link">Nuovo prodotto</router-link>
    </div>
  </div>
</template>

<script>
import ProductsService from '@/services/ProductsService'
export default {
  name: 'Products',
  data () {
    return {
        page: 0,
        count: 0,
        filters: [],
        products: []
    }
  },
  mounted () {
    this.getProducts()
  },
  methods: {
    gotoPage (page) {
        this.page = page
        this.getProducts()
    },
    async getProducts () {
      const response = await ProductsService.fetch({sku: this.filters.sku, ean: this.filters.ean, name: this.filters.name, page: this.page})
      this.products = response.data.products
      this.count = response.data.count
    },
    async deleteProduct (id) {
      await ProductsService.delete(id)
      const response = await ProductsService.fetch()
      this.products = response.data.products
      this.$router.push({ name: 'Products' })
    },
    formatDate (value) {
        if (!value) {
            return ''
        }
        var date = new Date(value)
        return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
    }
  }
}
</script>
<style type="text/css">
.table-wrap {
  /*width: 80%;
  margin: 0 auto;*/
  text-align: center;
}
table {
  /*width: 100%;*/
}
table th, table tr {
  text-align: left;
}
table thead {
  background: #f2f2f2;
}
table tr td {
  padding: 10px;
}
table tr:nth-child(odd) {
  background: #f2f2f2;
}
table tr:nth-child(1) {
  background: #4d7ef7;
  color: #fff;
}
a {
  color: #4d7ef7;
  text-decoration: none;
}
a.add_link {
  background: #4d7ef7;
  color: #fff;
  padding: 10px 80px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
}
.src_btn {
  background: #4d7ef7;
  color: #fff;
  padding: 10px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
  width: auto!important;
}
</style>



// WEBPACK FOOTER //
// src/components/Products.vue